import { State } from '../../types';

export const northCarolina: State = {
  name: 'North Carolina',
  abbreviation: 'NC',
  terms: [
    {
      word: 'Ahoskie',
      phonetic: 'uh-HOSS-kee',
      // audioUrl: '/audio/ahoskie.mp3',
      description: 'A town in Hertford County.'
    },
    {
      word: 'Appalachian',
      phonetic: 'ap-uh-LATCH-un',
      audioUrl: '/audio/appalachian.mp3',
      description: 'Mountain range and region in western North Carolina'
    },
    {
      word: 'Bahama',
      phonetic: 'ba-HAY-ma',
      // audioUrl: '/audio/bahama.mp3',
      description: 'An unincorporated community in northern Durham County.'
    },
    {
      word: 'Beaufort',
      phonetic: 'BO-furt',
      // audioUrl: '/audio/beaufort_nc.mp3',
      description: 'A town in Carteret County; not to be confused with Beaufort, SC.'
    },
    {
      word: 'Bertie County',
      phonetic: 'ber-TEE',
      // audioUrl: '/audio/bertie_county.mp3',
      description: 'A county located in the northeastern part of the state.'
    },
    {
      word: 'Chalybeate Springs',
      phonetic: 'ka-LIB-ee-ut',
      // audioUrl: '/audio/chalybeate_springs.mp3',
      description: 'A community in Harnett County.'
    },
    {
      word: 'Chinquapin',
      phonetic: 'CHINK-a-pin',
      // audioUrl: '/audio/chinquapin.mp3',
      description: 'A town in Duplin County.'
    },
    {
      word: 'Chocowinity',
      phonetic: 'chock-uh-WIN-uh-tee',
      // audioUrl: '/audio/chocowinity.mp3',
      description: 'A town in Beaufort County.'
    },
    {
      word: 'Conetoe',
      phonetic: 'kuh-NEE-tuh',
      // audioUrl: '/audio/conetoe.mp3',
      description: 'A town in Edgecombe County.'
    },
    {
      word: 'Cullowhee',
      phonetic: 'KULL-uh-wee',
      // audioUrl: '/audio/cullowhee.mp3',
      description: 'A community in Jackson County, home to Western Carolina University.'
    },
    {
      word: 'Fuquay-Varina',
      phonetic: 'FEW-kway vuh-REE-nah',
      // audioUrl: '/audio/fuquay_varina.mp3',
      description: 'A town in Wake County.'
    },
    {
      word: 'Mebane',
      phonetic: 'MEB-in',
      // audioUrl: '/audio/mebane.mp3',
      description: 'A city in Alamance County.'
    },
    {
      word: 'Nantahala',
      phonetic: 'nan-tuh-HAY-luh',
      // audioUrl: '/audio/nantahala.mp3',
      description: 'A region in the western part of the state, known for the Nantahala River.'
    },
    {
      word: 'Ocracoke',
      phonetic: 'OAK-ra-coke',
      // audioUrl: '/audio/ocracoke.mp3',
      description: 'A village on Ocracoke Island in Hyde County.'
    },
    {
      word: 'Saxapahaw',
      phonetic: 'SACKS-uh-pa-haw',
      // audioUrl: '/audio/saxapahaw.mp3',
      description: 'A census-designated place in Alamance County.'
    },
    {
      word: 'Wendell',
      phonetic: 'wen-DELL',
      // audioUrl: '/audio/wendell.mp3',
      description: 'A town in Wake County.'
    },
    {
      word: 'Zebulon',
      phonetic: 'ZEB-yoo-luhn',
      // audioUrl: '/audio/zebulon.mp3',
      description: 'A town in Wake County.'
    }
  ]
};